import { Component, Input, OnInit, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators } from '@angular/forms';
import { DocumentService } from '../../services/document.service';
import { SignaturePadComponent } from '../../commons/signature-pad/signature-pad.component';
import { MatSnackBar } from '@angular/material';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { learningArray } from '../../_models/staticArray'
import * as _moment from 'moment';
import * as _ from 'lodash';
import { saveAs } from "file-saver";
import * as moment from 'moment';
import { UserRoleService } from '../../services/user-role.service';
@Component({
  selector: 'app-individual-learner-profile',
  templateUrl: './individual-learner-profile.component.html',
  styleUrls: ['./individual-learner-profile.component.scss']
})
export class IndividualLearnerProfileComponent implements OnInit {


  @Input('learner') learner;
  @Input('job') job
  @Input('selectedJob') jobId
  // lnaArrayGlobal
  personalDetails: FormGroup;
  qualificationsForm: FormGroup;
  centerDetails: FormGroup;
  assessment: FormGroup;
  courseType: string;
  aln: FormGroup;
  iag: FormGroup;
  alp: FormGroup;
  rpl: FormGroup;
  lna: FormGroup;
  responsibility: FormGroup;
  selectedJob
  learnerFormData
  IAG: FormGroup
  learnerSign1 = false
  learnerSign2 = false
  learnerSign3 = false
  learnerSign4 = false
  learnerSign5 = false
  trainerSign1 = false
  trainerSign2 = false
  trainerSign3 = false
  trainerSign4 = false
  trainerSign5 = false
  singleFormDetails
  loading = false;
  learningArray = learningArray
  currentUser: any;
  user: any;
  isAdmin: boolean = false;
  isLearner: boolean = false;
  isIQA: boolean = false;
  isTrainer: boolean = false;
  lnaArrayGlobal: any;



  constructor(
    public formBuilder: FormBuilder,
    public documentService: DocumentService,
    public changeDetector: ChangeDetectorRef,
    public dialog: MatDialog,
    public _snackBar: MatSnackBar,
    public _userRoleService: UserRoleService

  ) {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
  }

  ngOnInit() {
    this.createForm()
  }

  ngOnChanges(changes: SimpleChanges) {
    console.log("%cchanges in ilp form", "color:red", changes)
    if (changes && changes.learner) {
      this.learner = changes.learner.currentValue
    }

    if (changes && changes.job && changes.job.currentValue) {
      this.job = changes.job.currentValue[0]
      console.log("%c job in changes", "color:purple", this.job)
      this.getUserRole();
      if (this.job && this.job.course && this.job.course.type == 'Level2') {
        console.log("in level 2")
        this.courseType = 'Level2'
        this.createLevel2Form()
        this.changeDetector.detectChanges()
      }
      else {
        console.log("in level 3")
        this.courseType = 'Level3'
        this.createForm()
        this.changeDetector.detectChanges()
      }
    }
    if (changes.jobId && changes.jobId.currentValue) {
      this.selectedJob = changes.jobId.currentValue
      console.log("this is selected job", this.selectedJob);
    }
    this.getLearnerIlpForm()

  }
  getUserRole() {
    let getRole = this._userRoleService.getUserRole(this.job.instructors, 'job');
    console.log("get.......", getRole);
    if (getRole.isAdmin) this.isAdmin = true
    else if (getRole.isLearner) this.isLearner = true
    else if (getRole.isTrainer) this.isTrainer = true
    else if (getRole.isIQA) this.isIQA = true
  }



  handleSnackBar(data) {
    this.openSnackBar(data.msg, data.button);
  }
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  createForm(details?) {
    console.log("createForm called")
    console.log("details in createLevel2Form here", details);
    this.personalDetails = new FormGroup({
      name: new FormControl((details && details.personalDetails) ? details.personalDetails.name : ''),
      telNo: new FormControl((details && details.personalDetails) ? details.personalDetails.telNo : ''),
      dob: new FormControl((details && details.personalDetails) ? details.personalDetails.dob : ''),
      age: new FormControl((details && details.personalDetails) ? details.personalDetails.age : ''),
      taDetails: this.formBuilder.array(this.taArray((details && details.personalDetails) ? details.personalDetails.taDetails : [])),
      iqaDetails: this.formBuilder.array(this.iqaArray((details && details.personalDetails) ? details.personalDetails.iqaDetails : [])),
      erDetails: this.formBuilder.array(this.erArray((details && details.personalDetails) ? details.personalDetails.erDetails : [])),
      startDate: new FormControl((details && details.personalDetails) ? details.personalDetails.startDate : ''),
      expectedEndDate: new FormControl((details && details.personalDetails) ? details.personalDetails.expectedEndDate : ''),
      actualEndDate: new FormControl((details && details.personalDetails) ? details.personalDetails.actualEndDate : ''),
      duration: new FormControl((details && details.personalDetails) ? details.personalDetails.duration : '')
    })

    this.qualificationsForm = new FormGroup({
      qualification: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.qualification : ''),
      learningAim: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.learningAim : ''),
      awardingOrg: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.awardingOrg : ''),
      plannedHrs: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.plannedHrs : ''),
      startDate: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.startDate : ''),
      endDate: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.endDate : '')
    })

    this.centerDetails = new FormGroup({
      name: new FormControl((details && details.centerDetails) ? details.centerDetails.name : ''),
      address: new FormControl((details && details.centerDetails) ? details.centerDetails.address : ''),
      telNo: new FormControl((details && details.centerDetails) ? details.centerDetails.telNo : ''),
      email: new FormControl((details && details.centerDetails) ? details.centerDetails.email : '',Validators.email)
    })

    this.assessment = new FormGroup({
      engLevel: new FormControl((details && details.assessment) ? details.assessment.engLevel : ''),
      engScore: new FormControl((details && details.assessment) ? details.assessment.engScore : ''),
      mathLevel: new FormControl((details && details.assessment) ? details.assessment.mathLevel : ''),
      mathScore: new FormControl((details && details.assessment) ? details.assessment.mathScore : '')
    })


    this.aln = new FormGroup({
      aln1: new FormControl((details && details.aln) ? details.aln.aln1 : false),
      aln2: new FormControl((details && details.aln) ? details.aln.aln2 : false),
      aln3: new FormControl((details && details.aln) ? details.aln.aln3 : false),
      aln4: new FormControl((details && details.aln) ? details.aln.aln4 : false),
      aln5: new FormControl((details && details.aln) ? details.aln.aln5 : false)
    })



    this.IAG = new FormGroup({
      value1: new FormControl((details && details.IAG) ? details.IAG.value1 : ''),
      learnerSign1: new FormControl((details && details.IAG) ? details.IAG.learnerSign1 : ''),
      learnerDate1: new FormControl((details && details.IAG) ? new Date(details.IAG.learnerDate1) : ''),
      trainerSign1: new FormControl((details && details.IAG) ? details.IAG.trainerSign1 : ''),
      trainerDate1: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate1) : ''),
      comment1: new FormControl((details && details.IAG) ? details.IAG.comment1 : ''),
      value2: new FormControl((details && details.IAG) ? details.IAG.value2 : ''),
      learnerSign2: new FormControl((details && details.IAG) ? details.IAG.learnerSign2 : ''),
      learnerDate2: new FormControl((details && details.IAG) ? details.IAG.learnerDate2 : ''),
      trainerSign2: new FormControl((details && details.IAG) ? details.IAG.trainerSign2 : ''),
      trainerDate2: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate2) : ''),
      comment2: new FormControl((details && details.IAG) ? details.IAG.comment2 : ''),
      value3: new FormControl((details && details.IAG) ? details.IAG.value3 : ''),
      learnerSign3: new FormControl((details && details.IAG) ? details.IAG.learnerSign3 : ''),
      learnerDate3: new FormControl((details && details.IAG) ? details.IAG.learnerDate3 : ''),
      trainerSign3: new FormControl((details && details.IAG) ? details.IAG.trainerSign3 : ''),
      trainerDate3: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate3) : ''),
      comment3: new FormControl((details && details.IAG) ? details.IAG.comment3 : ''),
    })




    // this.assessment = new FormGroup({
    //   assessment: this.formBuilder.array(this.assessmentArray())
    // })

    // this.aln = new FormGroup({
    //   aln: this.formBuilder.array(this.alnArray())
    // })

    // this.iag = new FormGroup({
    //   value1: new FormControl(),
    //   learnerSign1: new FormControl(),
    //   learnerDate1: new FormControl(),
    //   trainerSign1: new FormControl(),
    //   trainerDate1: new FormControl(),
    //   value2: new FormControl(),
    //   learnerSign2: new FormControl(),
    //   learnerDate2: new FormControl(),
    //   trainerSign2: new FormControl(),
    //   trainerDate2: new FormControl(),
    //   value3: new FormControl(),
    //   learnerSign3: new FormControl(),
    //   learnerDate3: new FormControl(),
    //   trainerSign3: new FormControl(),
    //   trainerDate3: new FormControl()
    // })

    this.alp = new FormGroup({
      personalGoal: new FormControl((details && details.alpQualification) ? details.alpQualification.personalGoal : ''),
      qualification: this.formBuilder.array(this.alpQualificationArray((details && details.alpQualification) ? ((details.alpQualification && details.alpQualification.qualification) ? details.alpQualification.qualification : details.alpQualification) : [])),
      fundingTotalCredits: new FormControl((details && details.alpQualification) ? details.alpQualification.fundingTotalCredits : ''),
      fundingRemaining: new FormControl((details && details.alpQualification) ? details.alpQualification.fundingRemaining : ''),
      propertionRemaining: new FormControl((details && details.alpQualification) ? details.alpQualification.propertionRemaining : '')
    })
    // (details && details.personalDetails) ? details.personalDetails.name)
    this.rpl = new FormGroup({
      aim: new FormControl(),
      unitDetails: this.formBuilder.array(this.rplUnitArray((details && details.rpl) ? ((details.rpl && details.rpl.unitDetails) ? details.rpl.unitDetails : details.rpl) : [])),
      fundingTotalCredits: new FormControl((details && details.rpl) ? details.rpl.fundingTotalCredits : ''),
      fundingRemaining: new FormControl((details && details.rpl) ? details.rpl.fundingRemaining : ''),
      propertionRemaining: new FormControl((details && details.rpl) ? details.rpl.propertionRemaining : ''),
      rowTotal: new FormControl((details && details.rpl) ? details.rpl.rowTotal : ''),
      rowTotal1: new FormControl((details && details.rpl) ? details.rpl.rowTotal1 : ''),
      rowTotal2: new FormControl((details && details.rpl) ? details.rpl.rowTotal2 : ''),
      rowTotal3: new FormControl((details && details.rpl) ? details.rpl.rowTotal3 : ''),
      rowTotal4: new FormControl((details && details.rpl) ? details.rpl.rowTotal4 : ''),
      rowTotal5: new FormControl((details && details.rpl) ? details.rpl.rowTotal5 : '')
    })

    this.lna = new FormGroup({
      lna: this.formBuilder.array(this.lnaArray((details && details.learningAnalysis) ? ((details.learningAnalysis && details.learningAnalysis.lna) ? details.learningAnalysis.lna : details.learningAnalysis) : [])),
    })


    console.log("value of LNA form========", this.lna);


    this.responsibility = new FormGroup({
      learnerSign1: new FormControl((details && details.responsibility) ? details.responsibility.learnerSign1 : ''),
      learnerDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.learnerDate1) : ''),
      taSign1: new FormControl((details && details.responsibility) ? details.responsibility.taSign1 : ''),
      taDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.taDate1) : ''),
      learnerSign2: new FormControl((details && details.responsibility) ? details.responsibility.learnerSign2 : ''),
      learnerDate2: new FormControl((details && details.responsibility) ? new Date(details.responsibility.learnerDate2) : ''),
      taSign2: new FormControl((details && details.responsibility) ? details.responsibility.taSign2 : ''),
      taDate2: new FormControl((details && details.responsibility) ? new Date(details.responsibility.taDate2) : ''),
      check1: new FormControl((details && details.responsibility) ? details.responsibility.check1 : false),
      check2: new FormControl((details && details.responsibility) ? details.responsibility.check2 : false)
    })


    // this.responsibility = new FormGroup({
    //   learnerSign1: new FormControl((details && details.responsibility) ? details.responsibility.learnerSign1 : ''),
    //   learnerDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.learnerDate1) : ''),
    //   taSign1: new FormControl((details && details.responsibility) ? details.responsibility.taSign1 : ''),
    //   taDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.taDate1) : ''),
    // })
  }

  onChangeEvent(value, formGroup, formControl) {
    console.log("value, formControl, formGroup", value, formControl, formGroup);

    if (formGroup == 'personalDetails')
      this.personalDetails.get(formControl).setValue(value);

    else if (formGroup == 'IAG')
      this.IAG.get(formControl).setValue(value);

    else if (formGroup == 'qualificationsForm')
      this.qualificationsForm.get(formControl).setValue(value);

    // else if (formGroup == 'lna')
    //   this.lna.get(formControl).setValue(value);

    else if (formGroup == 'responsibility')
      this.responsibility.get(formControl).setValue(value);
  }


  get personalDetailsTA() { return <FormArray>this.personalDetails.get('taDetails'); }
  taArray(data?) {
    let tempArray = []
    if (data) {
      data.forEach(obj => {
        tempArray.push(this.formBuilder.group({
          name: [obj ? obj.name : '', Validators.required],
          telNo: [obj ? obj.telNo : '', Validators.required]
        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })]
    }
  }

  get personalDetailsIQA() { return <FormArray>this.personalDetails.get('iqaDetails'); }
  iqaArray(data?) {
    let tempArray = []
    if (data) {
      data.forEach(obj => {
        tempArray.push(this.formBuilder.group({
          name: [obj ? obj.name : '', Validators.required],
          telNo: [obj ? obj.telNo : '', Validators.required]
        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })]
    }
  }

  get personalDetailsER() { return <FormArray>this.personalDetails.get('erDetails'); }
  erArray(data?) {
    let tempArray = []
    if (data) {
      data.forEach(obj => {
        tempArray.push(this.formBuilder.group({
          name: [obj ? obj.name : '', Validators.required],
          telNo: [obj ? obj.telNo : '', Validators.required]
        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })]
    }
  }

  assessmentArray(data?) {
    if (this.courseType == 'Level2') {
      let tempArray = []
      if (data) {
        data.forEach(obj => {
          tempArray.push(this.formBuilder.group({
            subject: [obj ? obj.subject : '', Validators.required],
            level: [obj ? obj.level : '', Validators.required],
          }))
        })
        return tempArray;
      } else {
        return [this.formBuilder.group({
          subject: ['', Validators.required],
          level: ['', Validators.required]
        })]
      }
    } else {
      let tempArray = []
      if (data) {
        data.forEach(obj => {
          tempArray.push(this.formBuilder.group({
            subject: [obj ? obj.subject : '', Validators.required],
            score: [obj ? obj.score : '', Validators.required],
            level: [obj ? obj.level : '', Validators.required]
          }))
        })
        return tempArray;
      } else {
        return [this.formBuilder.group({
          subject: ['', Validators.required],
          score: ['', Validators.required],
          level: ['', Validators.required]
        })]
      }
    }
  }

  alnArray(data?) {
    let tempArray = []
    if (data) {
      data.forEach(obj => {
        tempArray.push(this.formBuilder.group({
          level: [obj ? obj.name : '', Validators.required],
          value: [obj ? obj.telNo : '', Validators.required]
        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        level: ['', Validators.required],
        value: ['', Validators.required]
      })]
    }
  }


  get alpQualificationDetails() { return <FormArray>this.alp.get('qualification'); }
  alpQualificationArray(data?) {
    let tempArray = []
    if (data && data.length) {
      _.forEach(data, async (obj) => {
        await tempArray.push(new FormGroup({
          unitNo: new FormControl(obj ? obj.unitNo : ''),
          unitLevel: new FormControl(obj ? obj.unitLevel : ''),
          unitCredit: new FormControl(obj ? obj.unitCredit : ''),
          unitApl: new FormControl(obj ? obj.unitApl : ''),
        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        unitNo: ['',],
        unitLevel: ['',],
        unitCredit: ['',],
        unitApl: ['',]
      })]
    }
  }


  get rpliQualificationDetails() { return <FormArray>this.rpl.get('unitDetails'); }
  rplUnitArray(data?) {
    let tempArray = []

    if (data && data.length) {

      _.forEach(data, async (obj) => {
        await tempArray.push(new FormGroup({
          unitNo: new FormControl(obj ? obj.unitNo : ''),
          outcomes: new FormControl(obj ? obj.outcomes : ''),
          never: new FormControl(obj ? obj.never : ''),
          sometimes: new FormControl(obj ? obj.sometimes : ''),
          always: new FormControl(obj ? obj.always : ''),
          total: new FormControl(obj ? obj.total : ''),

        }))
      })
      return tempArray;
    } else {
      return [this.formBuilder.group({
        unitNo: ['',],
        outcomes: ['',],
        never: ['',],
        sometimes: ['',],
        always: ['',],
        total: ['',],
        // rowTotal: [''],
      })]
    }
  }


  get lnaQualificationDetails() { return <FormArray>this.lna.get('lna'); }
  lnaArray(data?) {

    let tempArray = []
    if (data && data.length) {
      this.lnaArrayGlobal = data;

      _.forEach(data, async (obj) => {
        // console.log("single obj valeu", obj);

        // console.log("what is the index", this.learningArray[index].learningOutcome);
        // console.log("value of insert data", data);

        await tempArray.push(new FormGroup({
          unitNo: new FormControl(obj ? obj.unitNo : ''),
          unitTitle: new FormControl(obj ? obj.unitTitle : ''),
          outcome: new FormControl(obj ? obj.outcome : ''),
          howToLearn: new FormControl(obj ? obj.howToLearn : ''),
          assessment: new FormControl(obj ? obj.assessment : ''),
          plannedDate: new FormControl(obj ? obj.plannedDate : ''),
          actualDate: new FormControl(obj ? obj.actualDate : ''),
        }))
      })
      console.log("what is the final out put of array", tempArray);

      return tempArray;
    } else {
      return [this.formBuilder.group({
        unitNo: ['',],
        unitTitle: ['',],
        outcome: ['',],
        howToLearn: ['',],
        assessment: ['',],
        plannedDate: ['',],
        actualDate: ['',]
      })]
    }
  }

  onChangeEventPlan(value, plannedDate, i) {
    let obj = this.lnaArrayGlobal[i]
    obj['plannedDate'] = value
    console.log("this for global define !!!!", obj)
    let controlArray = <FormArray>this.lna.controls["lna"];
    controlArray.controls[i].patchValue(obj);

  }

  onChangeEventActualDate(value, plannedDate, i) {

    let obj = this.lnaArrayGlobal[i]
    obj['actualDate'] = value
    console.log("this for global define !!!!", obj)
    let controlArray = <FormArray>this.lna.controls["lna"];
    controlArray.controls[i].patchValue(obj);

  }

  editPlaneDate(i) {
    if (this.lnaArrayGlobal) {
      return this.lnaArrayGlobal[i].plannedDate
    }
  }

  editActualDate(i) {
    if (this.lnaArrayGlobal) {
      return this.lnaArrayGlobal[i].actualDate
    }
  }

  createLevel2Form(details?) {
    console.log("details in createLevel2Form here", details);
    let trainerName = []
    if (details && details.personalDetails && details.personalDetails.trainer && details.personalDetails.trainer.length) {
      for (let i = 0; i < details.personalDetails.trainer.length; i++) {
        trainerName.push(details.personalDetails.trainer[i].name)
      }
    }

    this.personalDetails = new FormGroup({
      name: new FormControl((details && details.personalDetails) ? details.personalDetails.name : ''),
      uln: new FormControl((details && details.personalDetails) ? details.personalDetails.uln : ''),
      trainer: new FormControl((details && details.personalDetails && details.personalDetails.trainer && details.personalDetails.trainer.length) ? trainerName.join(', ') : ''),
      course: new FormControl((details && details.personalDetails) ? details.personalDetails.course : ''),
      startDate: new FormControl((details && details.personalDetails) ? new Date(details.personalDetails.startDate) : ''),
      expectedEndDate: new FormControl((details && details.personalDetails) ? new Date(details.personalDetails.expectedEndDate) : ''),
      actualEndDate: new FormControl((details && details.personalDetails) ? details.personalDetails.actualEndDate : ''),
      duration: new FormControl((details && details.personalDetails) ? details.personalDetails.duration : '')
    })

    this.qualificationsForm = new FormGroup({
      qualification: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.qualification : ''),
      learningAim: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.learningAim : ''),
      awardingOrg: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.awardingOrg : ''),

      qualification1: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.qualification1 : ''),
      learningAim1: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.learningAim1 : ''),
      awardingOrg1: new FormControl((details && details.qualificationsForm) ? details.qualificationsForm.awardingOrg1 : ''),
    })

    this.responsibility = new FormGroup({
      learnerSign1: new FormControl((details && details.responsibility) ? details.responsibility.learnerSign1 : ''),
      learnerDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.learnerDate1) : ''),
      taSign1: new FormControl((details && details.responsibility) ? details.responsibility.taSign1 : ''),
      taDate1: new FormControl((details && details.responsibility) ? new Date(details.responsibility.taDate1) : ''),
    })

    this.assessment = new FormGroup({
      engLevel: new FormControl((details && details.assessment) ? details.assessment.engLevel : ''),
      mathLevel: new FormControl((details && details.assessment) ? details.assessment.mathLevel : '')
    })

    this.aln = new FormGroup({
      aln1: new FormControl((details && details.aln) ? details.aln.aln1 : false),
      aln2: new FormControl((details && details.aln) ? details.aln.aln2 : false),
      aln3: new FormControl((details && details.aln) ? details.aln.aln3 : false),
      aln4: new FormControl((details && details.aln) ? details.aln.aln4 : false),
      aln5: new FormControl((details && details.aln) ? details.aln.aln5 : false)
    })



    this.IAG = new FormGroup({
      value1: new FormControl((details && details.IAG) ? details.IAG.value1 : ''),
      learnerSign1: new FormControl((details && details.IAG) ? details.IAG.learnerSign1 : ''),
      learnerDate1: new FormControl((details && details.IAG) ? new Date(details.IAG.learnerDate1) : ''),
      trainerSign1: new FormControl((details && details.IAG) ? details.IAG.trainerSign1 : ''),
      trainerDate1: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate1) : ''),
      comment1: new FormControl((details && details.IAG) ? details.IAG.comment1 : ''),
      value2: new FormControl((details && details.IAG) ? details.IAG.value2 : ''),
      learnerSign2: new FormControl((details && details.IAG) ? details.IAG.learnerSign2 : ''),
      learnerDate2: new FormControl((details && details.IAG) ? new Date(details.IAG.learnerDate2) : ''),
      trainerSign2: new FormControl((details && details.IAG) ? details.IAG.trainerSign2 : ''),
      trainerDate2: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate2) : ''),
      comment2: new FormControl((details && details.IAG) ? details.IAG.comment2 : ''),
      value3: new FormControl((details && details.IAG) ? details.IAG.value3 : ''),
      learnerSign3: new FormControl((details && details.IAG) ? details.IAG.learnerSign3 : ''),
      learnerDate3: new FormControl((details && details.IAG) ? new Date(details.IAG.learnerDate3) : ''),
      trainerSign3: new FormControl((details && details.IAG) ? details.IAG.trainerSign3 : ''),
      trainerDate3: new FormControl((details && details.IAG) ? new Date(details.IAG.trainerDate3) : ''),
      comment3: new FormControl((details && details.IAG) ? details.IAG.comment3 : ''),
    })


  }

  getOutcome(obj, index, type) {
    console.log("what is the obj at that time\\\\\\\\\\\\\\\\\\", obj, index, type);



  }
  // PERSONAL DETAILS TA
  addPersonalDetailsTa() {

    const control = <FormArray>this.personalDetails.controls.taDetails;
    control.push(
      this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })
    )
    console.log("FORM", this.personalDetails)
  }

  removePersonalDetailsTa(i) {
    const control = <FormArray>this.personalDetails.controls.taDetails;
    console.log("controlll => ", control);
    control.removeAt(i)
  }

  // PERSONAL DETAILS IQA
  addPersonalDetailsIQA() {
    const control = <FormArray>this.personalDetails.controls.iqaDetails;
    control.push(
      this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })
    )
    console.log("FORM", this.personalDetails)
  }

  removePersonalDetailsIQA(i) {
    const control = <FormArray>this.personalDetails.controls.iqaDetails;
    console.log("controlll => ", control);
    control.removeAt(i)
  }

  // PERSONAL DETAILS ER
  addPersonalDetailsER() {
    const control = <FormArray>this.personalDetails.controls.erDetails;
    control.push(
      this.formBuilder.group({
        name: ['', Validators.required],
        telNo: ['', Validators.required]
      })
    )
    console.log("FORM", this.personalDetails)
  }

  removePersonalDetailsER(i) {
    const control = <FormArray>this.personalDetails.controls.erDetails;
    console.log("controlll => ", control);
    control.removeAt(i)
  }



  addSignature(formType, fomrControl) {

    console.log("what is the form type", formType);
    console.log("form control name", fomrControl);
    if ((fomrControl === 'learnerSign1' || fomrControl === 'trainerSign1' || fomrControl === 'learnerSign2' || fomrControl === 'trainerSign2' || fomrControl === 'learnerSign3' || fomrControl === 'trainerSign3' || fomrControl === 'taSign2' || fomrControl === 'taSign1') && this.isIQA) {
      return;
    } else if ((fomrControl === 'learnerSign1' || fomrControl === 'learnerSign2' || fomrControl === 'learnerSign3') && this.isTrainer) {
      return;
    } else if ((fomrControl === 'trainerSign1' || fomrControl === 'trainerSign2' || fomrControl === 'trainerSign3' || fomrControl === 'taSign2' || fomrControl === 'taSign1') && this.isLearner) {
      return;
    } else {
      this.openDialog(SignaturePadComponent).subscribe((data) => {
        console.log("what is the value of sig", data);
        let sig = data
        if (sig == undefined) return;
        else if (formType == 'IAG') {
          if (fomrControl == 'learnerSign1') {
            this.learnerSign1 = true
            this.IAG.patchValue({
              learnerSign1: sig
            })
          }
          if (fomrControl == 'trainerSign1') {
            this.trainerSign1 = true
            this.IAG.patchValue({
              trainerSign1: sig
            })
          }
          if (fomrControl == 'learnerSign2') {
            this.learnerSign2 = true
            this.IAG.patchValue({
              learnerSign2: sig
            })
          }
          if (fomrControl == 'trainerSign2') {
            this.trainerSign2 = true
            this.IAG.patchValue({
              trainerSign2: sig
            })
          }
          if (fomrControl == 'learnerSign3') {
            this.learnerSign3 = true
            this.IAG.patchValue({
              learnerSign3: sig
            })
          }
          if (fomrControl == 'trainerSign3') {
            this.trainerSign3 = true
            this.IAG.patchValue({
              trainerSign3: sig
            })
          }
          console.log("what is the value of first sign of learner", this.IAG.value);
        } else if (formType == 'responsibility') {
          if (fomrControl == 'learnerSign1') {
            this.learnerSign4 = true
            this.responsibility.patchValue({
              learnerSign1: sig
            })
          }
          if (fomrControl == 'taSign1') {
            this.trainerSign4 = true
            this.responsibility.patchValue({
              taSign1: sig
            })
          }
          if (fomrControl == 'learnerSign2') {
            this.learnerSign5 = true
            this.responsibility.patchValue({
              learnerSign2: sig
            })
          }
          if (fomrControl == 'taSign2') {
            this.trainerSign5 = true
            this.responsibility.patchValue({
              taSign2: sig
            })
          }
        }
        console.log("this is the final form value", this.responsibility.value);

      })
    }

  }


  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, {
      data, maxWidth: '100vw',
      maxHeight: '100vh',
      height: '100%',
      width: '100%'
    });
    return dialogRef.afterClosed();
  }



  downloadIlpForm() {
    this.loading = true
    console.log("here is the ilp form =======>")
    // this.documentService.downloadIlpForm(this.courseType, this.learnerFormData, this.job).subscribe((response) => {
    // let details
    // if (this.courseType == 'Level2') {

    //   details = {
    //     courseType: this.courseType,
    //     personalDetails: this.personalDetails.value,
    //     qualificationsForm: this.qualificationsForm.value,
    //     responsibility: this.responsibility.value,
    //     assessment: this.assessment.value,
    //     aln: this.aln.value,
    //     IAG: this.IAG.value
    //   }



    // } else {

    //   details = {
    //     courseType: this.courseType,
    //     personalDetails: this.personalDetails.value,
    //     qualificationsForm: this.qualificationsForm.value,
    //     responsibility: this.responsibility.value,
    //     assessment: this.assessment.value,
    //     aln: this.aln.value,
    //     IAG: this.IAG.value,
    //     centerDetails: this.centerDetails.value,
    //     alpQualification: this.alp.value,
    //     rpl: this.rpl.value,
    //     learningAnalysis: this.lna.value

    //   }

    // }

    let obj = {
      learner: this.learner._id,
      jobId: this.selectedJob,
      courseType: this.courseType
    }
    this.documentService.downloadIlpFormPdf(obj).subscribe((res) => {
      console.log("here is reponse for the download document!!!", res)
      let byteArray = new Uint8Array(res.data.data);
      console.log("======byteArray =======", byteArray)
      let blob = new Blob([byteArray], { type: 'application/pdf' });
      console.log("blobblobblobblobblob", blob)
      let name = this.learnerFormData.personalDetails.name.split(' ').join('_')
      let title = name + '_ilp' + '_' + moment(new Date).format("DD-MM-YYYY")
      saveAs(blob, title);
      this.loading = false
    }, (error) => {
      this.loading = false
      console.log("reponse failed download ilp form", error);
    })
    // this.documentService.downloadIlpFormPdf(obj).subscribe((res) => {
    //   console.log("here is reponse for the download document!!!", res)
    //   let byteArray = new Uint8Array(res.data.data);
    //   console.log("======byteArray =======", byteArray)
    //   let blob = new Blob([byteArray], { type: 'application/pdf' });
    //   console.log("blobblobblobblobblob", blob)
    //   let name = this.learnerFormData.personalDetails.name.split(' ').join('_')
    //   let title = name + '_ilp' + '_' + moment(new Date).format("DD-MM-YYYY")
    //   saveAs(blob, title);
    //   this.loading = false
    // }, (error) => {
    //   this.loading = false
    //   console.log("reponse failed download ilp form", error);
    // })
    // this.documentService.downloadIlpFormPdf(details).subscribe((res) => {
    //   console.log("here is reponse for the download document!!!", res)
    //   let byteArray = new Uint8Array(res.data.data);
    //   console.log("======byteArray =======", byteArray)
    //   let blob = new Blob([byteArray], { type: 'application/pdf' });
    //   console.log("blobblobblobblobblob", blob)
    //   let name = this.learnerFormData.personalDetails.name.split(' ').join('_')
    //   let title = name + '_ilp' + '_' + moment(new Date).format("DD-MM-YYYY")
    //   saveAs(blob, title);
    //   this.loading = false
    // }, (error) => {
    //   this.loading = false
    //   console.log("reponse failed download ilp form", error);

    // }
    // )

    //   console.log("download form og ilp", response);
    //   this.loading = false
    // }, error => {
    //   console.log("error while download ilp form", error);
    //   this.loading = false
    // })

    // let form = this.documentService.downloadIlpForm(this.courseType, this.learnerFormData, this.singleFormDetails.learnerId.name)
    // console.log("downloaded of ilp form", form);

  }


  download() {
    this.loading = true
    console.log("all details of learner form", this.singleFormDetails);
    console.log("details of form whichc is to be displayed", this.learnerFormData);

    console.log("what is the course type of form", this.courseType);


    let finalArray = []
    if (this.courseType == 'Level2') {
      // headers.pop()
      if (this.learnerFormData.personalDetails) {
        finalArray.push(['personalDetails'], ['\r'], ['\r'])
        finalArray.push(['LearnerDetails'], ['\r'])
        let headers = ['Learner Name', 'ULN', 'Trainer', 'Course', 'Start Date', 'ExpectedEndDate', 'ActualEndDate', 'Duration']
        finalArray.push(headers, ['\r'])
        let item = this.learnerFormData.personalDetails
        let temp = []
        temp.push(item.name, item.uln, item.trainer[0].name, item.course, moment(item.startDate).format("DD-MM-YYYY"), moment(item.expectedEndDate).format("DD-MM-YYYY"), moment(item.actualEndDate).format("DD-MM-YYYY"), item.duration)
        console.log("what is the total temp value", temp);
        finalArray.push(temp, ['\r'], ['\r'])
      }
      if (this.learnerFormData.qualificationsForm) {
        finalArray.push(['Qualification Details'], ['\r'])
        let headers = ['Qualification', 'Learning Aim No', 'Awarding Organisation']
        finalArray.push(headers, ['\r'])

        let item = this.learnerFormData.qualificationsForm
        let temp = []
        let temp1 = []
        temp.push(item.qualification, item.learningAim, item.awardingOrg)
        finalArray.push(temp, ['\r'])
        temp1.push(item.qualification1, item.learningAim1, item.awardingOrg1)
        finalArray.push(temp1, ['\r'], ['\r'])
      }
      if (this.learnerFormData.assessment) {
        finalArray.push(['Initial Assessment / Diagonastic Results'], ['\r'])
        let headers = ['Subject', 'Level']
        finalArray.push(headers, ['\r'])

        let item = this.learnerFormData.assessment
        let temp = []
        let temp1 = []
        temp.push('English', item.engLevel)
        finalArray.push(temp, ['\r'])
        temp1.push('Maths', item.mathLevel)
        finalArray.push(temp1, ['\r'], ['\r'])
      }

      if (this.learnerFormData.aln) {
        finalArray.push(['Additional Learning Needs'], ['\r'])
        let headers = ['None', 'ASN - Maths', 'ALN - both', 'ASN - English', 'ASN']
        finalArray.push(headers, ['\r'])

        let item = this.learnerFormData.aln
        let temp = []
        // let temp1 = []
        temp.push(item.aln1, item.aln2, item.aln3, item.aln4, item.aln5)
        finalArray.push(temp, ['\r'], ['\r'])
        // temp1.push('Maths', item.mathLevel)
        // finalArray.push(temp1, ['\r'], ['\r'])
      }

      if (this.learnerFormData.IAG) {
        let item = this.learnerFormData.IAG
        finalArray.push(['Three Stages of Information, Advice and Guidance (IAG)'], ['\r'], ['\r'])
        let title = "\"" + " Getting into Learning: To be recorded as part of learner sign up e.g. ensuring programme is appropriate, assessing current skills and needs, identifying career goals and aspirations, discussing concerns and agreeing how needs will be met to ensure progression and learning style to meet objectives." + "\""
        let title1 = "\"" + "Review: To be recorded at mid-point of programme e.g. providing ongoing support to help maintain pace and momentum, reviewing goals and agreeing future options and actions required." + "\""
        let title2 = "\"" + "Moving on from Learning: To be recorded on learner exit e.g. discussing progression options into further learning and development that is appropriate to the learners needs what actions are required within appropriate timescales. Signposting learners to appropriate resources and organisations if applicable." + "\""
        let temp
        temp = title.replace(/,/g, " ").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
        // console.log("description value============", temp);
        if (item.value1) {
          finalArray.push([temp], ['\r'])
          finalArray.push(['Comments'], ['\r'])
          finalArray.push([item.comment1], ['\r'])
          finalArray.push(["\"" + item.value1.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let firstDate = []
          let secondDate = []
          firstDate.push('LearnerDate', moment(item.learnerDate1).format("DD-MM-YYYY"))
          finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'])
        }
        if (item.value2) {
          let temp1 = title1.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
          finalArray.push([temp1], ['\r'])
          finalArray.push(['Comments'], ['\r'])
          finalArray.push([item.comment2], ['\r'])
          finalArray.push(["\"" + item.value2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let firstDate = []
          let secondDate = []
          firstDate.push('LearnerDate', moment(item.learnerDate2).format("DD-MM-YYYY"))
          finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'])
        }
        if (item.value3) {
          let temp1 = title2.replace(/,/g, "|").split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next);
          finalArray.push([temp1], ['\r'])
          finalArray.push(['Comments'], ['\r'])
          finalArray.push([item.comment3], ['\r'])
          finalArray.push(["\"" + item.value3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let firstDate = []
          let secondDate = []
          firstDate.push('LearnerDate', moment(item.learnerDate3).format("DD-MM-YYYY"))
          finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate3).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'], ['\r'])
        }
      }

      if (this.learnerFormData.responsibility) {
        let item = this.learnerFormData.responsibility
        finalArray.push(['Responsibilities'], ['\r'], ['\r'])
        finalArray.push(['The Learners Responsibilities', 'The Training Providers Responsibilities'], ['\r'])
        let title1 = "\"" + 'In both working and training to be,diligent and punctual, to attend courses,keep records and contribute to the review process, undertake assessments in order to achieve Individual Learning Plan objectives and keep the employer informed of progress towards those objectives' + "\""
        let temp1 = title1.replace(/,/g, " ")
        let title8 = 'To check that the contents of the Individual Learning Plan fulfil the national and industry / sector agreed criteria for the programme.'
        finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title8.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let titel2 = 'At all times to behave in a safe and responsible manner and in accordance with the requirements of health and safety legislation relating to the individuals responsibilities and to promote and act in the employers best interests.'
        let title9 = 'To conduct a progress review with the learner and employer at least every 8 weeks.'
        finalArray.push(["\"" + titel2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title9.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title3 = 'Commit to making sure evidence is submitted in line with SMART targets.'
        let title10 = 'To deliver the programme as described in this plan, and in line with the appropriate framework awarding organisation and end point assessment (if applicable) requirements.'
        let temp10 = title10.replace(/,/g, " ")
        finalArray.push(["\"" + title3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp10.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title4 = 'Communicate all non-attendance or session changes within a timely manner.'
        let title11 = 'To ensure that the training meets the requirements set out in the contract between the Training Provider and the Skills Funding Agency, in particular in relation to the quality assurance process including health and safety obligations.'
        let temp11 = title11.replace(/,/g, " ")
        finalArray.push(["\"" + title4.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp11.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title5 = 'Complete the diagnostic assessment (if applicable) within the first 6 weeks of your programme.'
        let title12 = 'To provide an appeals procedure for learners who disagree with advice or an assessment decision. Full details of the appeals procedure are given to all learners either via E-Portfolio or their Awarding Organisation standards. The contact details required by learners are detailed on Page2.'
        finalArray.push(["\"" + title5.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title12.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title6 = 'Communicate to the Training Provider any changes in situation.'
        let title13 = 'To safeguard all learners in line with company policies and procedures.'
        finalArray.push(["\"" + title6.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title13.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title7 = 'Ensure that all work submitted towards your qualification is your own work.Plagiarism is taken very seriously within Profound Group and this could result in the termination of your qualification.'
        let title14 = 'Carry out a thorough assessment to identify the additional learning support (Additional Funding) the Apprentice needs and if appropriate record in the ILR that an Apprentice has a learning support need.'
        finalArray.push(["\"" + title7.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title14.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title15 = 'Agree and record the outcomes of the additional learning support assessment,deliver support in line with the identified needs, record all outcomes in the evidence pack,and retain evidence of the assessment.'
        let temp15 = title15.replace(/,/g, " ")
        // finalArray.push([temp15], ['\r'])
        finalArray.push(['', "\"" + temp15.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
        let title16 = 'I agree that I have been involved in drawing up this plan to understand,and agree with its contents and to my responsibilities detailed above:'
        let temp16 = title16.replace(/,/g, " ")
        finalArray.push(["\"" + temp16.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        finalArray.push(['LearnerDate', moment(item.learnerDate1).format("DD-MM-YYYY")], ['\r'])
        finalArray.push(['TrainerDate', moment(item.taDate1).format("DD-MM-YYYY")], ['\r'])
      }
    } else {
      console.log("this is for level 3 jobs");
      finalArray.push(['personalDetails'], ['\r'], ['\r'])

      if (this.learnerFormData.personalDetails) {
        finalArray.push(['LearnerDetails'], ['\r'])
        let headers = ['Learner Name', 'Tel. No', 'Date Of Birth', 'Age']
        finalArray.push(headers, ['\r'])
        let item = this.learnerFormData.personalDetails
        let temp = []
        temp.push(item.name, item.telNo, moment(item.dob).format("DD-MM-YYYY"), item.age)
        console.log("what is the total temp value", temp);
        finalArray.push(temp, ['\r'], ['\r'])
        if (item.taDetails && item.taDetails.length) {
          finalArray.push(['TA Name', 'TA Tel. No'], ['\r'])
          item.taDetails.forEach((single) => {
            let temp = []
            temp.push(single.name, single.telNo)
            finalArray.push(temp, ['\r'])
          })
          finalArray.push(['\r'])
        }
        if (item.iqaDetails && item.iqaDetails.length) {
          finalArray.push(['IQA Name', 'IQA Tel. No'], ['\r'])
          item.iqaDetails.forEach((single) => {
            let temp = []
            temp.push(single.name, single.telNo)
            finalArray.push(temp, ['\r'])
          })
          finalArray.push(['\r'])
        }
        if (item.erDetails && item.erDetails.length) {
          finalArray.push(['Emergency Name', 'Emergency Tel. No'], ['\r'])
          item.erDetails.forEach((single) => {
            let temp = []
            temp.push(single.name, single.telNo)
            finalArray.push(temp, ['\r'])
          })
          finalArray.push(['\r'])
        }
        finalArray.push(['Start Date', 'Expected End Date', 'Actual End Date', 'Planned Duration'], ['\r'])
        finalArray.push([moment(item.startDate).format("DD-MM-YYYY"), moment(item.expectedEndDate).format("DD-MM-YYYY"), moment(item.actualEndDate).format("DD-MM-YYYY"), item.duration], ['\r'], ['\r'])

      }

      if (this.learnerFormData.qualificationsForm) {
        finalArray.push(['Qualification Details'], ['\r'])
        let headers = ['Qualification', 'Learning Aim No', 'Awarding Organisation', 'Planned Learning Hours', 'Start Date', 'End Date']
        finalArray.push(headers, ['\r'])

        let item = this.learnerFormData.qualificationsForm
        let temp = []
        temp.push(item.qualification, item.learningAim, item.awardingOrg, item.plannedHrs, moment(item.startDate).format("DD-MM-YYYY"), moment(item.endDate).format("DD-MM-YYYY"))
        finalArray.push(temp, ['\r'], ['\r'])
      }
      if (this.learnerFormData.centerDetails) {
        finalArray.push(['Center Details'], ['\r'])
        let headers = ['Provider Name', 'Provider Address', 'Tel. No.', 'Email']
        finalArray.push(headers, ['\r'])
        let item = this.learnerFormData.centerDetails
        let temp = []
        temp.push(item.name, item.address, item.telNo, item.email)
        finalArray.push(temp, ['\r'], ['\r'])
      }

      if (this.learnerFormData.assessment) {
        finalArray.push(['Initial Assessment / Diagonastic Results'], ['\r'])
        let headers = ['Subject', 'Score', 'Level']
        finalArray.push(headers, ['\r'])

        let item = this.learnerFormData.assessment
        let temp = []
        let temp1 = []
        temp.push('English', item.engScore, item.engLevel)
        finalArray.push(temp, ['\r'])
        temp1.push('Maths', item.mathScore, item.mathLevel)
        finalArray.push(temp1, ['\r'], ['\r'])
      }
      if (this.learnerFormData.aln) {
        finalArray.push(['Additional Learning Needs'], ['\r'])
        let headers = ['None', 'ASN - Maths', 'ALN - both', 'ASN - English', 'ASN']
        finalArray.push(headers, ['\r'])
        let item = this.learnerFormData.aln
        let temp = []
        temp.push(item.aln1, item.aln2, item.aln3, item.aln4, item.aln5)
        finalArray.push(temp, ['\r'], ['\r'])
      }
      if (this.learnerFormData.IAG) {
        let item = this.learnerFormData.IAG
        finalArray.push(['Three Stages of Information, Advice and Guidance (IAG)'], ['\r'], ['\r'])
        let title = "\"" + 'Getting into Learning: To be recorded as part of learner sign up e.g. ensuring programme is appropriate, assessing current skills and needs,identifying career goals and aspirations, discussing concerns and agreeing how needs will be met to ensure progression and learning style to meet objectives.' + "\""
        let title1 = "\"" + 'Review:To be recorded at mid-point of programme e.g. providing ongoing support to help maintain pace and momentum, reviewing goals and agreeing future options and actions required.' + "\""
        let title2 = "\"" + 'Moving on from Learning:To be recorded on learner exit e.g. discussing progression options into further learning and development that is appropriate to the learners needs what actions are required within appropriate timescales.Signposting learners to appropriate resources and organisations if applicable.' + "\""
        let temp
        temp = title.replace(/,/g, "|")
        // console.log("description value============", temp);
        if (item.value1) {
          finalArray.push([temp.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next)], ['\r'])
          finalArray.push(["\"" + item.value1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let secondDate = []
          // firstDate.push('LearnerDate', item.learnerDate1)
          // finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate1).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'])
        }
        if (item.value2) {
          let temp1 = title1.replace(/,/g, "|")
          finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          finalArray.push(["\"" + item.value2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let secondDate = []
          // firstDate.push('LearnerDate', item.learnerDate2)
          // finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate2).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'])
        }
        if (item.value3) {
          let temp1 = title2.replace(/,/g, "|")
          finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          finalArray.push(["\"" + item.value3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
          let secondDate = []
          // firstDate.push('LearnerDate', item.learnerDate3)
          // finalArray.push(firstDate, ['\r'])
          secondDate.push('TrainerDate', moment(item.trainerDate3).format("DD-MM-YYYY"))
          finalArray.push(secondDate, ['\r'], ['\r'])
        }
      }

      if (this.learnerFormData.alpQualification) {
        let item = this.learnerFormData.alpQualification
        finalArray.push(['APL'], ['\r'], ['\r'])
        finalArray.push(['What are your personal goals while attending this programme?'], ['\r'])
        if (this.learnerFormData.alpQualification && this.learnerFormData.alpQualification.personalGoal) {
          finalArray.push(["\"" + item.personalGoal.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
        }

        finalArray.push(['Qualification (Title & Level):'], ['\r'])
        if (item.qualification && item.qualification.length) {
          // finalArray.push(['Unit Number',])
          let temp = ['Unit Number']
          item.qualification.forEach((single) => {
            temp.push(single.unitNo)
          })
          finalArray.push(temp, ['\r'])
        }
        if (item.qualification && item.qualification.length) {
          // finalArray.push(['Unit Level',])
          let temp = ['Unit Level']
          item.qualification.forEach((single) => {
            temp.push(single.unitLevel)
          })
          finalArray.push(temp, ['\r'])
        }
        if (item.qualification && item.qualification.length) {
          // finalArray.push(['Unit Credit Value',])
          let temp = ['Unit Credit Value']
          item.qualification.forEach((single) => {
            temp.push(single.unitCredit)
          })
          finalArray.push(temp, ['\r'])
        }
        if (item.qualification && item.qualification.length) {
          // finalArray.push(['State if APL',])
          let temp = ['State if APL']
          item.qualification.forEach((single) => {
            temp.push(single.unitApl)
          })
          finalArray.push(temp, ['\r'], ['\r'])
        }
        finalArray.push(['Qualification Proportion of Funding'], ['\r'])
        finalArray.push(['Total Credits of Aim', item.fundingTotalCredits], ['\r'])
        finalArray.push(['Remaining Credits following APL', item.fundingRemaining], ['\r'])
        finalArray.push(['Proportion of Funding Remaining', item.propertionRemaining], ['\r'], ['\r'])
      }



      if (this.learnerFormData.rpl) {
        let item = this.learnerFormData.rpl
        finalArray.push(['RPL'], ['\r'], ['\r'])
        finalArray.push(['Competency Aim (Title & Level): Level 3 Diploma in Engineering Technology -Rail'])
        if (item.unitDetails && item.unitDetails.length) {
          for (let i = 0; i < item.unitDetails.length; i++) {
            finalArray.push([','])
          }
        }
        finalArray.push([','], ['Total'], ['\r'])

        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['Unit Number',])
          let temp = ['Unit Number']
          item.unitDetails.forEach((single) => {
            temp.push(single.unitNo)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'])
        }
        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['Unit Level',])
          let temp = ['Number of Outcomes']
          item.unitDetails.forEach((single) => {
            temp.push(single.outcomes)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'])
        }
        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['Unit Credit Value',])
          let temp = ['Never']
          item.unitDetails.forEach((single) => {
            temp.push(single.never)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'])
        }
        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['State if APL',])
          let temp = ['Sometimes']
          item.unitDetails.forEach((single) => {
            temp.push(single.sometimes)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'])
        }
        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['State if APL',])
          let temp = ['Always']
          item.unitDetails.forEach((single) => {
            temp.push(single.always)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'])
        }
        if (item.unitDetails && item.unitDetails.length) {
          // finalArray.push(['State if APL',])
          let temp = ['Total']
          item.unitDetails.forEach((single) => {
            temp.push(single.total)
          })
          temp.push('test')
          finalArray.push(temp, ['\r'], ['\r'])
        }
        finalArray.push(['Qualification Proportion of Funding'], ['\r'])
        finalArray.push(['Total Credits of Aim', item.fundingTotalCredits], ['\r'])
        finalArray.push(['Remaining Credits following APL', item.fundingRemaining], ['\r'])
        finalArray.push(['Proportion of Funding Remaining', item.propertionRemaining], ['\r'], ['\r'])
      }

      if (this.learnerFormData.learningAnalysis) {
        finalArray.push(['Learning Needs Analysis'], ['\r'], ['\r'])
        let headers = ['Unit Title ', ' Unit No', 'Learning Outcome ', 'How will I learn?', 'Assessment Method', ' Planned End Date', 'Actual Completion Date']
        finalArray.push(headers, ['\r'])
        let item = this.learnerFormData.learningAnalysis

        if (item.lna && item.lna.length) {

          item.lna.forEach((single) => {
            let temp = []
            temp.push(single.unitTitle, single.unitNo, single.outcome, single.howToLearn, single.assessment, moment(single.plannedDate).format("DD-MM-YYYY"), moment(single.actualDate).format("DD-MM-YYYY"))
            finalArray.push(temp, ['\r'])
          })
        }

        if (item && !item.lna) {

          item.forEach((single) => {
            let temp = []
            temp.push(single.unitTitle, single.unitNo, single.outcome, single.howToLearn, single.assessment, moment(single.plannedDate).format("DD-MM-YYYY"), moment(single.actualDate).format("DD-MM-YYYY"))
            finalArray.push(temp, ['\r'])
          })
        }

        finalArray.push(['\r'])
      }


      if (this.learnerFormData.responsibility) {
        let item = this.learnerFormData.responsibility
        finalArray.push(['Responsibilities'], ['\r'], ['\r'])
        finalArray.push(['The Learners Responsibilities', 'The Training Providers Responsibilities'], ['\r'])
        let title1 = 'In both working and training to be,diligent and punctual, to attend courses,keep records and contribute to the review process, undertake assessments in order to achieve Individual Learning Plan objectives and keep the employer informed of progress towards those objectives'
        let temp1 = title1.replace(/,/g, " ")
        let title8 = 'To check that the contents of the Individual Learning Plan fulfil the national and industry / sector agreed criteria for the programme.'
        finalArray.push(["\"" + temp1.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title8.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let titel2 = 'At all times to behave in a safe and responsible manner and in accordance with the requirements of health and safety legislation relating to the individuals responsibilities and to promote and act in the employers best interests.'
        let title9 = 'To conduct a progress review with the learner and employer at least every 8 weeks.'
        finalArray.push(["\"" + titel2.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title9.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title3 = 'Commit to making sure evidence is submitted in line with SMART targets.'
        let title10 = 'To deliver the programme as described in this plan, and in line with the appropriate framework awarding organisation and end point assessment (if applicable) requirements.'
        let temp10 = title10.replace(/,/g, " ")
        finalArray.push(["\"" + title3.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp10.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title4 = 'Communicate all non-attendance or session changes within a timely manner.'
        let title11 = 'To ensure that the training meets the requirements set out in the contract between the Training Provider and the Skills Funding Agency, in particular in relation to the quality assurance process including health and safety obligations.'
        let temp11 = title11.replace(/,/g, " ")
        finalArray.push(["\"" + title4.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + temp11.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title5 = 'Complete the diagnostic assessment (if applicable) within the first 6 weeks of your programme.'
        let title12 = 'To provide an appeals procedure for learners who disagree with advice or an assessment decision. Full details of the appeals procedure are given to all learners either via E-Portfolio or their Awarding Organisation standards. The contact details required by learners are detailed on Page2.'
        finalArray.push(["\"" + title5.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title12.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title6 = 'Communicate to the Training Provider any changes in situation.'
        let title13 = 'To safeguard all learners in line with company policies and procedures.'
        finalArray.push(["\"" + title6.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title13.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title7 = 'Ensure that all work submitted towards your qualification is your own work.Plagiarism is taken very seriously within Profound Group and this could result in the termination of your qualification.'
        let title14 = 'Carry out a thorough assessment to identify the additional learning support (Additional Funding) the Apprentice needs and if appropriate record in the ILR that an Apprentice has a learning support need.'
        finalArray.push(["\"" + title7.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\"", "\"" + title14.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title15 = 'Agree and record the outcomes of the additional learning support assessment,deliver support in line with the identified needs, record all outcomes in the evidence pack,and retain evidence of the assessment.'
        let temp15 = title15.replace(/,/g, " ")
        // finalArray.push([temp15], ['\r'])
        finalArray.push(['', "\"" + temp15.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'], ['\r'])
        let title17 = 'We are unable to offer a fully-funded first full level 3 for this programme of learning, we have signposted the learner to the National Careers Service to obtain information about alternative providers. Therefore, as you have chosen to apply for loan rather than exercising your legal entitlement to full funding for a first full level 3 qualification, you are aware that this may mean you give up your right to exercise your legal entitlement in future.'
        let temp17 = title17.replace(/,/g, " ")
        finalArray.push(["\"" + temp17.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        let title18 = 'I agree that I understand that I may give up my right to a fully funded level 3 qualification'
        finalArray.push(["\"" + title18.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        finalArray.push(['LearnerDate', moment(item.learnerDate1).format("DD-MM-YYYY")], ['\r'])
        finalArray.push(['TrainerDate', moment(item.taDate1).format("DD-MM-YYYY")], ['\r'])
        let title19 = 'I agree that I have been involved in drawing up this plan to understand, and agree with its contents and to my responsibilities detailed above: '
        let temp19 = title19.replace(/,/g, " ")
        finalArray.push(["\"" + temp19.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])

        let title16 = 'I agree that I have been involved in drawing up this plan to understand,and agree with its contents and to my responsibilities detailed above:'
        let temp16 = title16.replace(/,/g, " ")
        finalArray.push(["\"" + temp16.split(" ").reduce((prev, next, id) => prev + (id % 14 ? " " : "\n") + next) + "\""], ['\r'])
        finalArray.push(['LearnerDate', moment(item.learnerDate2).format("DD-MM-YYYY")], ['\r'])
        finalArray.push(['TrainerDate', moment(item.taDate2).format("DD-MM-YYYY")], ['\r'])
      }

    }


    console.log("final array to print=======", finalArray);

    if (finalArray && finalArray.length) {

      finalArray.forEach(row => {
        let line = "";
        let columns =
          typeof row !== "object" ? JSON.parse(row) : Object.values(row);
        columns.forEach(column => {
          if (line !== "") {
            line += ";";
          }
          if (typeof column === "object") {
            line += JSON.stringify(column);
          } else {
            line += column;
          }
        });
      });


      let blob = new Blob(finalArray, { type: 'text/csv;charset=utf-8;' });
      let location = []
      this.job.clients.forEach((item) => {
        location.push(item.location.title)
      })
      let title = 'Individual-Learner-Profile_' + location.join('-') + '_' + moment(new Date).format("DD-MM-YYYY")
      // let title = jobName ? jobName + "Register" : 'Register'
      saveAs(blob, title + ".csv");

    }

  }



  // Api Call








  getLearnerIlpForm() {
    this.loading = true
    console.log("selected learner id", this.learner);
    console.log("selected job id", this.selectedJob);
    if (this.learner != undefined && this.selectedJob != undefined) {
      let obj = {
        learner: this.learner._id,
        jobId: this.selectedJob
      }
      this.documentService.getLearnerIlpForm(JSON.stringify(obj)).subscribe((response) => {
        if (response && response.length) {
          this.learnerFormData = response[0].details
          this.singleFormDetails = response[0]
          this.loading = false
          // console.log("what is the course typer", this.courseType)
          console.log("response of ilp form", response);
          if (this.courseType == 'Level2') {
            // console.log("typeof this.learnerFormData.personalDetails.trainer", typeof this.learnerFormData.personalDetails.trainer);

            if (typeof this.learnerFormData.personalDetails.trainer == 'string') {
              console.log("call or not");

              let trainerData = []
              let obj = {
                name: this.learnerFormData.personalDetails.trainer
              }
              trainerData.push(obj)
              this.learnerFormData.personalDetails.trainer = trainerData
            }
            this.createLevel2Form(this.learnerFormData)
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign1 != '') {
              this.learnerSign1 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign1 != '') {
              this.trainerSign1 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign2 != '') {
              this.learnerSign2 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign2 != '') {
              this.trainerSign2 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign3 != '') {
              this.learnerSign3 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign3 != '') {
              this.trainerSign3 = true
            }

            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.learnerSign1 != '') {
              this.learnerSign4 = true
            }
            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.taSign1 != '') {
              this.trainerSign4 = true
            }

          } else {


            _.forEach(this.learnerFormData.learningAnalysis, (single, index) => {
              // console.log("what is the single analysis=============", single, index);
              // console.log("what is the value of index", this.learningArray[index]);
              if (this.learningArray[index] != undefined) {
                single['outcome'] = this.learningArray[index].learningOutcome
                single['howToLearn'] = this.learningArray[index].howToLearn
                single['assessment'] = this.learningArray[index].assessment
              }
            })
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign1 != '') {
              this.learnerSign1 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign1 != '') {
              this.trainerSign1 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign2 != '') {
              this.learnerSign2 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign2 != '') {
              this.trainerSign2 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.learnerSign3 != '') {
              this.learnerSign3 = true
            }
            if (this.learnerFormData.IAG && this.learnerFormData.IAG.trainerSign3 != '') {
              this.trainerSign3 = true
            }

            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.learnerSign1 != '') {
              this.learnerSign4 = true
            }
            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.learnerSign2 != '') {
              this.learnerSign5 = true
            }
            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.taSign1 != '') {
              this.trainerSign4 = true
            }

            if (this.learnerFormData.responsibility && this.learnerFormData.responsibility.taSign2 != '') {
              this.trainerSign5 = true
            }


            this.createForm(this.learnerFormData)
          }
        }
        this.loading = false
      }, error => {
        console.log("error while get ilp form", error);
        this.loading = false

      })
    }
  }

  /**
   * Form save of ILP
   */
  saveForm() {
    this.loading = true

    let obj = {
      metaObj: {
        title: 'ILP',
      },
      jobId: this.selectedJob,
      onModel: 'job',
      learnerId: this.learner._id,
      documentMetaId: this.singleFormDetails.documentMetaId,
      documentId: this.singleFormDetails._id,
      details: {}
    }
    if (this.courseType == 'Level2') {

      let details = {
        personalDetails: this.personalDetails.value,
        qualificationsForm: this.qualificationsForm.value,
        responsibility: this.responsibility.value,
        assessment: this.assessment.value,
        aln: this.aln.value,
        IAG: this.IAG.value
      }

      obj['details'] = details

    } else {
      // This is for level3 job
      let details = {
        personalDetails: this.personalDetails.value,
        qualificationsForm: this.qualificationsForm.value,
        responsibility: this.responsibility.value,
        assessment: this.assessment.value,
        aln: this.aln.value,
        IAG: this.IAG.value,
        centerDetails: this.centerDetails.value,
        alpQualification: this.alp.value,
        rpl: this.rpl.value,
        learningAnalysis: this.lna.value



      }
      obj['details'] = details





    }

    console.log("what is the final value of level2 form", obj);



    this.documentService.updateForm(obj).subscribe((response) => {
      console.log("response of form update", response);
      this.loading = false
      this.handleSnackBar({ msg: "Document saved successfully!", button: "Ok" });
    }, err => {
      console.log("error while update form", err);
      this.loading = false
      this.handleSnackBar({ msg: 'Something went wrong!', button: 'OK' })

    })


  }

}

